import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import LocalShippingOutlinedIcon from '@mui/icons-material/LocalShippingOutlined';
import PercentOutlinedIcon from '@mui/icons-material/PercentOutlined';
import StoreIcon from '@mui/icons-material/Store';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import { Product } from '@interfaces';
import {
  addBusinessDays,
  extractMiddleDate,
  getWeekdayName,
  next24hrsDay,
} from '@utils';
import { addDays } from 'date-fns';
import {
  ContentContainer,
  IconContainer,
  InfoTagContainer,
  InfoTagContent,
  InfoTagTitle,
  Strong,
} from './InfoTag.styles';

interface InfoTagProps {
  backgroundColor: string;
  icon: React.ReactNode;
  color: string;
  iconColor: string;
  title: React.ReactNode;
  detail?: React.ReactNode;
}
const InfoTag = (props: InfoTagProps) => {
  return (
    <InfoTagContainer>
      <IconContainer
        iconColor={props.iconColor}
        backgroundColor={props.backgroundColor}
      >
        {props.icon}
      </IconContainer>
      <ContentContainer>
        <InfoTagTitle color={props.color}>{props.title}</InfoTagTitle>
        {props.detail && <InfoTagContent>{props.detail}</InfoTagContent>}
      </ContentContainer>
    </InfoTagContainer>
  );
};
const extractDeliveryDate = (product: Product) => {
  const availability = product.availability?.status;
  if (availability === 'AVAILABLE_24_HRS') {
    const next = next24hrsDay();
    return extractMiddleDate(next);
  }
  if (['REPRESENTATION', 'AVAILABLE'].includes(availability)) {
    const next = addBusinessDays(new Date(Date.now()), 3);
    return extractMiddleDate(next);
  }
  return null;
};
const extractNearDay = (product: Product) => {
  const availability = product.availability?.status;
  if (availability === 'AVAILABLE_24_HRS') {
    const next = next24hrsDay();
    if (next.toDateString() === new Date().toDateString()) return 'hoy';
    if (next.toDateString() === addDays(new Date(), 1).toDateString())
      return 'mañana';
    if (next.toDateString() === addBusinessDays(new Date(), 1).toDateString())
      return 'el ' + getWeekdayName(next);
  }
  if (['AVAILABLE', 'REPRESENTATION'].includes(availability)) {
    const next = addBusinessDays(new Date(Date.now()), 3);
    return getWeekdayName(next);
  }
  return null;
};

interface InfoTagDeliveryDateProps {
  product: Product;
  maxQuantity?: number;
}
export const InfoTagDeliveryDate = (props: InfoTagDeliveryDateProps) => {
  const deliveryDate = extractDeliveryDate(props.product);
  const nearDate = extractNearDay(props.product);
  const express = props.product.availability?.status === 'AVAILABLE_24_HRS';
  const title = express ? (
    <span>
      Recibe <Strong>{nearDate}</Strong>
    </span>
  ) : (
    <span>Recibe el {nearDate}</span>
  );
  const detail = props.maxQuantity
    ? `${props.maxQuantity} un. con entrega ${deliveryDate}`
    : deliveryDate;
  return (
    <InfoTag
      icon={<LocalShippingOutlinedIcon />}
      backgroundColor={express ? '#00a650' : '#757475'}
      color={express ? '#00a650' : '#414046'}
      iconColor="white"
      title={title}
      detail={detail}
    />
  );
};

interface InfoTagCheapestProps {
  activePrinciple: string;
}
export const InfoTagCheapest = (props: InfoTagCheapestProps) => {
  return (
    <InfoTag
      icon={<AttachMoneyIcon />}
      backgroundColor="#5D5FEF"
      color="#5D5FEF"
      iconColor="white"
      title={
        <span>
          Comprimido <Strong>más económico</Strong>
        </span>
      }
      detail={`de ${props.activePrinciple}`}
    />
  );
};

export const InfoTagOnDemand = () => {
  return (
    <InfoTag
      icon={<AccessTimeIcon />}
      backgroundColor="#fff0d6"
      color="#603e11"
      iconColor="#ffa200"
      title={
        <span>
          Producto <Strong>a pedido</Strong>
        </span>
      }
      detail="Entrega estimada de 3 semanas"
    />
  );
};

export const InfoTagSoldOut = () => {
  return (
    <InfoTag
      icon={<WarningAmberIcon />}
      backgroundColor="#ffe2e2"
      color="#602d11"
      iconColor="#ff0000"
      title={
        <span>
          Producto <Strong>agotado</Strong>
        </span>
      }
    />
  );
};

export const InfoTagLocalSell = () => {
  return (
    <InfoTag
      icon={<StoreIcon />}
      backgroundColor="#f2eff5"
      color="#2d0076"
      iconColor="#731eff"
      title={
        <span>
          Solo <Strong>venta presencial</Strong>
        </span>
      }
      detail="Medicamento con receta cheque"
    />
  );
};

interface InfoTagDiscountTypeProps {
  type: string;
}
export const InfoTagDiscountType = (props: InfoTagDiscountTypeProps) => {
  const { type } = props;

  const title = (type: string) => {
    if (type == 'EXPIRATION') {
      return (
        <div>
          Descuento por <Strong>vencimiento</Strong>
        </div>
      );
    }
  };

  const detail =
    type === 'EXPIRATION'
      ? 'entre 2 y 6 meses'
      : type === 'MEKI'
      ? 'precios bajos para todos, todos los días'
      : null;

  const color = '#5D5FEF';
  const backgroundColor = '#5D5FEF';
  return (
    <InfoTag
      icon={<PercentOutlinedIcon />}
      backgroundColor={backgroundColor}
      color={color}
      iconColor="white"
      title={title(type)}
      detail={detail}
    />
  );
};
